// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"660":"14b781af","777":"aaabec25"}[chunkId] + ".chunk.js";
};